<template>
  <div class="container">
    <!-- Rreshti i parë me 3 karta -->
    <div class="row justify-content-center flex-row">
      <div class="custom-card firstCard first-row" v-for="(card, index) in firstRow" :key="'first-' + index">
        <div class="shadow p-3 bg-body rounded h-80" @click="goToLegislation(card.button)" :style="{
          borderLeft: `6px solid var(--color-${card.color})`,
          backgroundColor:
            this.subdomain === card.title.toLowerCase()
              ? '#F5BD2A !important'
              : this.subdomain === card.button
                ? '#F5BD2A !important'
                : '#FFFFFF',
            color:
            this.subdomain === card.title.toLowerCase()
              ? 'white'
              : 'inherit' }">
          <!-- <div class="card-header fw-bold">{{ card.title }}</div> -->
          <div class="card-body">
            <blockquote class="blockquote mb-0">
              <p :class="card.bold ? 'fw-bold' : ''">{{ card.text }}</p>
              <footer v-if="card.footer" class="blockquote-footer">
                {{ card.footer }}
                <cite v-if="card.source" :title="card.source">{{ card.source }}</cite>
              </footer>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center flex-row">
      <div class="custom-card firstCard third-row" v-for="(card, index) in thirdRow" :key="'first-' + index">
        <div class="shadow p-3 bg-body rounded h-80" @click="goToLegislation(card.button)" :style="{
          borderLeft: `6px solid var(--color-${card.color})`,
          backgroundColor:
            this.subdomain === card.title.toLowerCase()
              ? '#F5BD2A !important'
              : this.subdomain === card.button
                ? '#F5BD2A !important'
                : '#FFFFFF',
          color:
            this.subdomain === card.title.toLowerCase()
              ? 'white'
              : 'inherit'}">
          <!-- <div class="card-header fw-bold">{{ card.title }}</div> -->
          <div class="card-body">
            <blockquote class="blockquote mb-0">
              <p :class="card.bold ? 'fw-bold' : ''">{{ card.text }}</p>
              <footer v-if="card.footer" class="blockquote-footer">
                {{ card.footer }}
                <cite v-if="card.source" :title="card.source">{{ card.source }}</cite>
              </footer>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <titleArea :title="$t('sistemi_prokurorial.second_menu.title')" />
    </div>
    <!-- Rreshti i dytë -->
    <div class="row justify-content-center flex-row">
      <div class="custom-card second-row" v-for="(card, index) in secondRow" :key="'second-' + index">
        <div class="shadow p-3 rounded bg-body h-60" @click="goToLegislation(card.button)" :style="{
          borderLeft: `6px solid var(--color-${card.color})`,
          backgroundColor:
            this.subdomain === card.button.toLowerCase()
              ? '#F5BD2A !important'
              : 'transparent',
          color:
            this.subdomain === card.button.toLowerCase()
              ? 'white'
              : 'inherit'}">
          <div class="card-header fw-bold">{{ card.title }}</div>
          <div class="card-body">
            <blockquote class="blockquote mb-0">
              <p :class="card.bold ? 'fw-bold' : ''">{{ card.text }}</p>
              <footer v-if="card.footer" class="blockquote-footer">
                {{ card.footer }}
                <cite v-if="card.source" :title="card.source">{{ card.source }}</cite>
              </footer>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useMenuStore } from '@/store/MenuStore';
import titleArea from '../share/TitleArea.vue';

export default {
  data() {
    return {
      menuStore: useMenuStore(),
      cards: [],
      subsdomain: null,
    }
  },
  components:{
    titleArea
  },
  computed: {
    // firstRow() {
    //   return this.primaryMenu.slice(0, 4);
    // },
    secondRow() {
      return this.cards.slice(6);
    },
    thirdRow() {
      return this.cards.slice(4,6);
    },

    primaryMenu() {
      return [
        { title: "", text: this.$t('sistemi_prokurorial.second_menu.system_title'), bold: true, button: "prokuroria-rks.org", color: 'system', externalUrl: "https://prokuroria-rks.org/" },
        { title: "", text: this.$t('sistemi_prokurorial.second_menu.firstCard.kpk'), bold: true, button: "kpk", color: 'kpk', externalUrl: "https://kpk.prokuroria-rks.org" },
        { title: "", text: this.$t('sistemi_prokurorial.second_menu.firstCard.zkpsh'), bold: true, button: "zkpsh", color: 'zkpsh', externalUrl: "https://zkpsh.prokuroria-rks.org" },
        { title: "", text: this.$t('sistemi_prokurorial.second_menu.firstCard.sekretariati'), bold: true, button: "sekretariati", color: 'sekretariati', externalUrl: "https://sekretariati.prokuroria-rks.org" },
        { title: "", text: this.$t('sistemi_prokurorial.second_menu.firstCard.pa'), bold: true, button: "pa", color: 'pa', externalUrl: "https://pa.prokuroria-rks.org" },
        { title: "", text: this.$t('sistemi_prokurorial.second_menu.firstCard.ps'), bold: true, button: "ps", color: 'ps', externalUrl: "https://ps.prokuroria-rks.org" },
        { title: "", text: this.$t('sistemi_prokurorial.second_menu.secondCard.prishtine'), bold: true, button: "pthprishtine", color: 'prishtine', externalUrl: "https://pthprishtine.prokuroria-rks.org" },
        { title: "", text: this.$t('sistemi_prokurorial.second_menu.secondCard.prizren'), bold: true, button: "pthprizren", color: 'prizren', externalUrl: "https://pthprizren.prokuroria-rks.org" },
        { title: "", text: this.$t('sistemi_prokurorial.second_menu.secondCard.ferizaj'), bold: true, button: "pthferizaj", color: 'ferizaj', externalUrl: "https://pthferizaj.prokuroria-rks.org" },
        { title: "", text: this.$t('sistemi_prokurorial.second_menu.secondCard.peje'), bold: true, button: "pthpeje", color: 'peje', externalUrl: "https://pthpeje.prokuroria-rks.org" },
        { title: "", text: this.$t('sistemi_prokurorial.second_menu.secondCard.mitrovice'), bold: true, button: "pthmitrovice", color: 'mitrovic', externalUrl: "https://pthmitrovice.prokuroria-rks.org" },
        { title: "", text: this.$t('sistemi_prokurorial.second_menu.secondCard.gjilan'), bold: true, button: "pthgjilan", color: 'gjilan', externalUrl: "https://pthgjilan.prokuroria-rks.org" },
        { title: "", text: this.$t('sistemi_prokurorial.second_menu.secondCard.gjakove'), bold: true, button: "pthgjakove", color: 'gjakove', externalUrl: "https://pthgjakove.prokuroria-rks.org" }
      ]
    }
  },

  methods: {
    goToLegislation(button) {
      const card = this.cards.find(c => c.button === button);
      console.log(card)
      if (card) {
        window.open(card.externalUrl);
      } else {
        this.$router.push(button);
      }
    },

  },

  created() {
    this.cards = this.primaryMenu;
    this.subdomain = this.menuStore.subdomain;
  }
}
</script>

<style scoped>
.card-body blockquote p {
  font-size: 16px;
}

.col div {
  cursor: pointer;
}

.bg-body:hover {
  transform: scale(1.06);
  background-color: #F5BD2A !important;
}

.shadow {
  transition: transform 0.3s ease;
}

.shadow:hover {
  transform: scale(1.06);
  z-index: 1;
  background-color: #F5BD2A !important;
  color: white;
}

.custom-card {
  padding: 10px;
  cursor: pointer;
}

.first-row {
  width: 25%;
  /* 5 items per row on desktop */
}

.second-row {
  width: 14.28%;
  /* 7 items per row on desktop */
}
.third-row {
  width: 50%;
  /* 7 items per row on desktop */
}

h3 {
  color: #0B0A21;
}

.firstCard .card-body {
  height: 50px;
}

@media (max-width: 1200px) {
  .first-row,
  .second-row {
    width: 25%;
    /* 4 per row */
  }
}

@media (max-width: 992px) {
  .first-row,
  .second-row {
    width: 33.33%;
    /* 3 per row */
  }
}

@media (max-width: 768px) {

  .first-row,
  .second-row {
    width: 50%;
    /* 2 per row */
  }
}

@media (max-width: 576px) {

  .first-row{
     width: 50%;
  }
  .second-row {
    width: 50%;
    /* 1 per row */
  }
  
  .firstCard .card-body {
    height: 70px;
  }
}




</style>